import NumberPad from './NumberPad';

export default {
  NumberPad,
};
